var React = require('react');

function Callback (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29.0667 0H12.9333C11.3141 0 10 1.31267 10 2.93333V13.2C10 14.8207 11.3141 16.1333 12.9333 16.1333H21.7333L29.0667 22V16.1333C30.6873 16.1333 32 14.8207 32 13.2V2.93333C32 1.31267 30.6873 0 29.0667 0ZM9 14.1429V7H3C1.344 7 0 8.28 0 9.85714V18.4286C0 20.0057 1.344 21.2857 3 21.2857H4.5V27L13.5 21.2857H18C19.6575 21.2857 21 20.0057 21 18.4286V17H12C10.3425 17 9 15.7214 9 14.1429Z"}));
}

Callback.defaultProps = {"width":"32","height":"27","viewBox":"0 0 32 27","fill":"none"};

module.exports = Callback;

Callback.default = Callback;
